import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { getRegisteredApiClient, getRegisteredOrgId } from '@/lib/auth-store';
import { projectsListOptions } from '@/lib/query-options';

export const Route = createFileRoute('/projects')({
  loader: ({ context: { queryClient } }) => {
    const apiClient = getRegisteredApiClient();
    const orgId = getRegisteredOrgId();
    if (!apiClient || !orgId) return;
    return queryClient.ensureQueryData(
      projectsListOptions(apiClient, orgId, { page: 1, limit: 20 })
    );
  },
  component: lazyRouteComponent(() => import('./-projects.lazy'), 'default'),
});
